import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Drawer, Checkbox, Subheader, SelectField, MenuItem } from 'material-ui';
import { getViewOptions } from 'src/models/TaskViewOptions';
import { getCardDisplayOptions } from '../models/CardDisplayVersions';
import api from '../api';
var TaskViewOptionSection = inject('preferencesStore')(observer(function (_a) {
    var preferencesStore = _a.preferencesStore, cardViewFilter = _a.cardViewFilter;
    return (React.createElement(React.Fragment, null,
        React.createElement(Subheader, null, "Feladat l\u00E1that\u00F3s\u00E1g"),
        React.createElement(SelectField, { style: { marginTop: '-20px', marginLeft: '5px' }, underlineStyle: { visibility: 'hidden' }, value: cardViewFilter.value, onChange: function (e, _, value) {
                cardViewFilter.set(value);
                preferencesStore.changed._fire();
            } }, getViewOptions().map(function (i) { return React.createElement(MenuItem, { key: i, primaryText: i, value: i }); }))));
}));
var AppSettings = /** @class */ (function (_super) {
    tslib_1.__extends(AppSettings, _super);
    function AppSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.handleRequestChange = function (opening) {
            _this.props.preferencesStore.isSettingsOpened = opening;
        };
        return _this;
    }
    AppSettings.prototype.render = function () {
        var _this = this;
        var _a = this.props.preferencesStore, isSettingsOpened = _a.isSettingsOpened, sprintChooserVisible = _a.sprintChooserVisible, taskFilterVisible = _a.taskFilterVisible, cardDetailVisible = _a.cardDetailVisible, cardProgressVisible = _a.cardProgressVisible, cardAvatarVisible = _a.cardAvatarVisible, cardViewFilter = _a.cardViewFilter, cardDisplayVersion = _a.cardDisplayVersion, displayClosedCards = _a.displayClosedCards, independentColumnScrolling = _a.independentColumnScrolling;
        var viewOptionSelect = !this.props.userStore.loggedInUserIsAdmin
            ? null
            : React.createElement(TaskViewOptionSection, { cardViewFilter: cardViewFilter });
        if (!this.props.projectStore.configuration) {
            return null;
        }
        return (React.createElement(Drawer, { open: isSettingsOpened, docked: false, width: 250, onRequestChange: this.handleRequestChange },
            React.createElement(Subheader, null, "N\u00E9zet"),
            !this.props.projectStore.configuration.isProjectIntervalBased ? null : (React.createElement(Checkbox, { label: "Sprint v\u00E1laszt\u00F3", checked: sprintChooserVisible.value, onCheck: function (e, value) { return _this.props.preferencesStore.sprintChooserVisible.set(value); } })),
            React.createElement(Subheader, null, "R\u00E9szleg"),
            React.createElement(SelectField, { underlineStyle: { visibility: 'hidden' }, value: this.props.userStore.selectedSection, onChange: function (e, _, value) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var changed;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                changed = this.props.userStore.selectedSection !== Number(value);
                                this.props.userStore.selectedSection = value;
                                api.defaults.headers["X-Boardy-SectionId"] = value;
                                if (!changed) return [3 /*break*/, 3];
                                return [4 /*yield*/, this.props.taskStore.loadSprint(this.props.taskStore.sprintIndex)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, this.props.taskStore.loadTasks(this.props.userStore.userIdForLoading)];
                            case 2:
                                _a.sent();
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); } }, this.props.userStore.sections.map(function (s) { return React.createElement(MenuItem, { key: s.sectionID, primaryText: s.sectionName, value: s.sectionID }); })),
            React.createElement(Checkbox, { label: "F\u00FCggetlen oszlop scroll", checked: independentColumnScrolling.value, onCheck: function (e, value) { return _this.props.preferencesStore.independentColumnScrolling.set(value); } }),
            React.createElement(Checkbox, { label: "Feladat sz\u0171r\u0151", checked: taskFilterVisible.value, onCheck: function (e, value) { return _this.props.preferencesStore.taskFilterVisible.set(value); } }),
            React.createElement(Checkbox, { label: "K\u00E1rtya teljes\u00EDtetts\u00E9g", checked: cardProgressVisible.value, onCheck: function (e, value) { return _this.props.preferencesStore.cardProgressVisible.set(value); } }),
            React.createElement(Checkbox, { label: "K\u00E1rtya avatar", checked: cardAvatarVisible.value, onCheck: function (e, value) { return _this.props.preferencesStore.cardAvatarVisible.set(value); } }),
            React.createElement(Checkbox, { label: "K\u00E1rtya r\u00E9szletek", checked: cardDetailVisible.value, onCheck: function (e, value) { return _this.props.preferencesStore.cardDetailVisible.set(value); } }),
            !this.props.projectStore.configuration.showClosedTasks ? null : (React.createElement(Checkbox, { label: "Lez\u00E1rt k\u00E1rty\u00E1k", checked: displayClosedCards.value, onCheck: function (e, value) { return _this.props.preferencesStore.displayClosedCards.set(value); } })),
            viewOptionSelect,
            React.createElement(Subheader, null, "K\u00E1rtya megjelen\u00E9se"),
            React.createElement(SelectField, { underlineStyle: { visibility: 'hidden' }, value: cardDisplayVersion.value, onChange: function (e, _, value) {
                    cardDisplayVersion.set(value);
                    _this.props.preferencesStore.changed._fire();
                } }, getCardDisplayOptions().map(function (i) { return React.createElement(MenuItem, { key: i, primaryText: i, value: i }); }))));
    };
    AppSettings = tslib_1.__decorate([
        inject('projectStore', 'preferencesStore', 'userStore', 'taskStore'),
        observer
    ], AppSettings);
    return AppSettings;
}(React.Component));
export default AppSettings;



//////////////////
// WEBPACK FOOTER
// ./src/layout/AppSettings.tsx
// module id = 479
// module chunks = 0